import "./GetInTouch.module.css";
import Navigation from "@/reusable_sections/Header";
import KontaktEjerneDirekte from "./sections/KontaktEjerneDirekte";
import ContactUs from "./sections/ContactUs";
import FittingFaq from "./sections/FittingFaq";
import Footer from "@/reusable_sections/Footer";
export default function GetInTouchPage() {
  return <div>
      <Navigation />
      <KontaktEjerneDirekte />
      <ContactUs />
      <FittingFaq />
      <Footer />
    </div>;
}